export interface ILastConnectionLike {
    isConnected?: boolean;
    redirectUrl?: string;
}

/**
 * Returns the URL to redirect to when the resolved last-used org is an SSO
 * connection on a DIFFERENT subdomain than `currentHost`; otherwise null.
 * The host check prevents an infinite reload loop on the connected subdomain.
 */
export const getCrossSubdomainRedirect = (
    lastConnection: ILastConnectionLike | null | undefined,
    currentHost: string
): string | null => {
    if (!lastConnection || !lastConnection.isConnected || !lastConnection.redirectUrl) {
        return null;
    }
    try {
        return new URL(lastConnection.redirectUrl).host !== currentHost
            ? lastConnection.redirectUrl
            : null;
    } catch {
        return null;
    }
};

/** Side-effecting redirect, wrapped so the saga can yield it as an assertable `call` effect. */
export const redirectTo = (url: string): void => {
    window.location.href = url;
};
